import { format, parseISO } from 'date-fns';

/**
 *
 * @param dateString
 * @returns
 */
export const formatDate = (dateString: string) =>
  format(parseISO(dateString), 'MM/dd/yyyy')
